PaymentRedirection = function () {
    var init = function () {
        if (typeof gaSend === "function") {
            gaSend();
        }

        var paymentUrlElement = document.getElementById('paymentRedirect');

        if (typeof paymentUrlElement === 'undefined' || paymentUrlElement === null) {
            return;
        }

        var paymentUrl = paymentUrlElement.getAttribute('data-url');

        if (paymentUrl === null || paymentUrl.length === 0) {
            return;
        }

        setTimeout(function () {
            window.location.href = paymentUrl;
        }, 5000);
    };

    return {
        init: function () {
            init();
        }
    };
}();
if (typeof (PaymentRedirection) != "undefined") {
    PaymentRedirection.init();
}